<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Histórico</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div v-show="loading" class="ui active inverted dimmer">
          <div class="ui text loader">Carregando...</div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui form search-form">
              <div class="fields">
                <div class="ten wide field">
                  <label for="contract-search-description">Usuário</label>
                  <input
                    type="text"
                    name="history-search-user"
                    v-model="searchForm.user"
                  />
                </div>
                <div class="field">
                  <label for="history-search-event">Evento</label>
                  <select
                    id="history-search-event"
                    class="ui dropdown"
                    v-model="searchForm.event"
                  >
                    <option :value="null">Todos</option>
                    <option
                      v-for="(evt, index) in events"
                      :key="index"
                      :value="evt.value"
                    >
                      {{ evt.description }}
                    </option>
                  </select>
                </div>
                <div class="field">
                  <label for="history-search-register">Cadastro</label>
                  <select
                    id="history-search-register"
                    class="ui dropdown"
                    v-model="searchForm.register"
                  >
                    <option :value="null">Todos</option>
                    <option
                      v-for="(register, index) in registers"
                      :key="index"
                      :value="register.value"
                    >
                      {{ register.description }}
                    </option>
                  </select>
                </div>
                <div class="field">
                  <label for="contract-search-id">ID</label>
                  <input
                    type="text"
                    name="history-search-id"
                    v-model="searchForm.id"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <table class="ui striped table">
              <thead>
                <tr>
                  <th></th>
                  <th>Data</th>
                  <th>Cadastro</th>

                  <th>Evento</th>
                  <th>ID</th>
                  <th>Usuário</th>

                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <div
                  class="neutral"
                  v-for="(version, index) in versions"
                  :key="index"
                >
                  <tr>
                    <td class="center aligned">
                      <a
                        v-show="Object.keys(version.item_changes).length > 0"
                        @click.prevent="open_details($event)"
                        ><i class="caret right icon"></i
                      ></a>
                    </td>
                    <td>
                      {{ getFormattedDate(version.created_at) }}
                    </td>
                    <td>{{ getRegisterDescription(version.item_type) }}</td>
                    <td>{{ getEventDescription(version.event) }}</td>
                    <td>{{ version.item_id }}</td>
                    <td>{{ (version.who || {})['name'] }}</td>
                    <td>{{ version.message }}</td>
                  </tr>
                  <tr class="details hide">
                    <td colspan="7">
                      <div class="ui segment">
                        <table class="ui very basic table">
                          <thead>
                            <th>Campo</th>
                            <th>Antes</th>
                            <th>Depois</th>
                          </thead>
                          <tbody>
                            <div class="neutral">
                              <tr
                                v-for="change_key in Object.keys(
                                  version.item_changes
                                )"
                                :key="change_key"
                              >
                                <td class="bold">{{ change_key }}</td>
                                <td>
                                  {{ version.item_changes[change_key][0] }}
                                </td>
                                <td>
                                  {{ version.item_changes[change_key][1] }}
                                </td>
                                <td></td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </div>
              </tbody>
              <tfoot>
                <tr v-show="pageCount > 1">
                  <th :colspan="7" class="right aligned">
                    <Paginate
                      :page-count="pageCount"
                      :click-handler="changePage"
                      :total="paginate.total_entries"
                      :entries="entriesOnPage"
                    ></Paginate>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import historyEnum from '@/enumerations/history_enum.js';
import Paginate from '@/components/grid/widgets/paginate';

export default {
  name: 'histories',
  components: { Paginate, Breadcrumb, PageLayout },

  data() {
    return {
      searchForm: {
        user_name: null,
        register: null,
        id: null,
        event: null
      },
      paginate: {
        current_page: null,
        per_page: null,
        total_entries: null
      },
      loading: false,
      versions: [],
      events: historyEnum.events,
      registers: _.sortBy(historyEnum.registers, 'description')
    };
  },

  computed: {
    pageCount() {
      return Math.ceil(this.paginate.total_entries / this.paginate.per_page);
    },

    entriesOnPage() {
      const page_count = Math.ceil(
        this.paginate.total_entries / this.paginate.per_page
      );

      if (this.paginate.current_page === 1) {
        return page_count === 1
          ? this.paginate.total_entries
          : this.paginate.per_page;
      }

      return (
        this.paginate.total_entries %
        ((page_count - 1) * this.paginate.per_page)
      );
    }
  },

  methods: {
    changePage(page) {
      this.search(page);
    },

    open_details(evt) {
      var $icon = window.$(evt.target);
      var $details = $icon.closest('tr').next('tr.details');
      if ($icon.hasClass('right')) {
        $icon.removeClass('right');
        $icon.addClass('down');

        $details.removeClass('hide');
      } else {
        $icon.removeClass('down');
        $icon.addClass('right');

        $details.addClass('hide');
      }
    },

    getRegisterDescription(register) {
      const description = historyEnum.registers.find(
        registerFind => registerFind.value === register
      )?.description;
      return description;
    },

    getEventDescription(evt) {
      const description = historyEnum.events.find(
        eventFind => eventFind.value === evt
      )?.description;
      return description;
    },

    getFormattedDate(date) {
      const formattedDate = this.$moment(date)
        .locale('pt')
        .format('ddd[,] DD [de] MMMM [de] YYYY[,] HH:mm:ss');
      return formattedDate;
    },

    search(page = 1) {
      const query = {
        q: {
          item_type_eq: this.searchForm.register,
          event_eq: this.searchForm.event,
          item_id_eq: this.searchForm.id,
          s: ['updated_at asc']
        },
        page: page
      };

      this.loading = true;
      Api.versions
        .search(query)
        .then(async response => {
          this.versions = _.clone(response.data.versions);
          this.paginate = _.clone(response.data.pagination);
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
